import { useCallback, useEffect, useRef, useState } from 'react';
import { Button, type ButtonHandle } from '@progress/kendo-react-buttons';
import { Calendar, type CalendarChangeEvent } from '@progress/kendo-react-dateinputs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar } from '@fortawesome/free-solid-svg-icons';
import { Popup } from '@progress/kendo-react-popup';
import type { SamplingDateToolbarPickerProps } from './sampling-date-toolbar-picker.types.ts';
import styles from './sampling-date-toolbar-picker.module.scss';

export function SamplingDateToolbarPicker({ selectedDate, onChange }: SamplingDateToolbarPickerProps) {
  const [showPopup, setShowPopup] = useState(false);
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  const buttonRef = useRef<ButtonHandle | null>(null);

  useEffect(() => {
    if (buttonRef.current?.element) {
      setAnchor(buttonRef.current.element);
    }
  }, []);

  const togglePopup = useCallback(() => {
    setShowPopup((prev) => !prev);
  }, []);

  const handleDateChange = useCallback(
    (e: CalendarChangeEvent) => {
      onChange(e);
      setShowPopup(false);
    },
    [onChange]
  );

  return (
    <div>
      <Button
        ref={buttonRef}
        themeColor={'primary'}
        className={`${styles.btn} ${styles.iconBtn}`}
        onClick={togglePopup}
      >
        <FontAwesomeIcon icon={faCalendar} size={'lg'} transform={{ y: 1 }} />
      </Button>
      <Popup
        anchor={anchor}
        show={showPopup}
        anchorAlign={{ horizontal: 'right', vertical: 'bottom' }}
        popupAlign={{ horizontal: 'right', vertical: 'top' }}
      >
        <Calendar value={selectedDate} onChange={handleDateChange} />
      </Popup>
    </div>
  );
}
